import { render } from "./DiscardChangesPrompt.vue?vue&type=template&id=2187c414&scoped=true"
import script from "./DiscardChangesPrompt.vue?vue&type=script&lang=js"
export * from "./DiscardChangesPrompt.vue?vue&type=script&lang=js"

import "./DiscardChangesPrompt.vue?vue&type=style&index=0&id=2187c414&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2187c414"

export default script